import {
  onAuthStateChanged as _onAuthStateChanged,
  onIdTokenChanged as _onIdTokenChanged,
  NextOrObserver,
  User,
  signInWithCustomToken,
  signOut as _signOut,
} from 'firebase/auth'

import { auth } from './client-app'

export type FirebaseUser = User

export const onAuthStateChanged = (callback: NextOrObserver<FirebaseUser>) => {
  return _onAuthStateChanged(auth, callback)
}

export function onIdTokenChanged(callback: NextOrObserver<FirebaseUser>) {
  return _onIdTokenChanged(auth, callback)
}

export async function signInWithToken(customToken: string) {
  try {
    await signInWithCustomToken(auth, customToken)
  } catch (error) {
    console.error('Error signing in with Token', error)
  }
}

export async function signOut() {
  try {
    if (auth?.currentUser) {
      await _signOut(auth)
    }

    return
  } catch (error) {
    console.error('Error signing out with Token', error)
  }
}
